/* ═══════════════════════════════════════════════════════════════
   Clerk configuration — auth front door (docs/AUTH_CLERK_PLAN.md)

   Clerk owns sign-in UI, passwords, Microsoft SSO, reset, invites.
   The EC2 API exchanges a Clerk session token for the SpecForma JWT
   via POST /auth/clerk-exchange — everything downstream unchanged.

   The publishable key is PUBLIC by design (it only identifies the
   instance). Production swap: set VITE_CLERK_PUBLISHABLE_KEY at build.
   ═══════════════════════════════════════════════════════════════ */

export const CLERK_PUBLISHABLE_KEY =
  (import.meta as any).env?.VITE_CLERK_PUBLISHABLE_KEY || 'pk_live_Y2xlcmsuc3BlY2Zvcm1hLmFwcCQ';

/** Clerk-hosted account portal (password change, connected accounts, sessions). */
export const CLERK_ACCOUNT_URL =
  (import.meta as any).env?.VITE_CLERK_ACCOUNT_URL || 'https://accounts.specforma.app/user';

/** Web page the desktop app opens for browser sign-in (query flag, NOT a path —
    the Cloudflare worker proxies /auth/* to the API, so a path would never
    reach the SPA). */
export const DESKTOP_SIGNIN_URL = 'https://specforma.app/?desktop-signin=1';

/** Deep link the web handoff fires to hand the session back to the exe. */
export const DESKTOP_DEEP_LINK_PREFIX = 'specforma://auth#token=';

export function isDesktopSigninRequest(): boolean {
  try {
    return new URLSearchParams(window.location.search).has('desktop-signin');
  } catch {
    return false;
  }
}
